module.exports = __webpack_public_path__ + "img/icomoon.1b6719cd.svg";